$(() => {
  appendQuoteCardAccordionClickListners();
});

const appendQuoteCardAccordionClickListners = () => {
  $("body").on(
    "click",
    ".cover_excesses_accordion .accordion_header",
    function () {
      const $accordion = $(this).parent();
      $accordion.toggleClass("expand");
    },
  );

  $("body").on("click", ".accordion_header", function () {
    EventTracker.trigger("view_deductables_clicked");
  });
};

export default appendQuoteCardAccordionClickListners;
